import React, {useEffect, useState} from 'react';
import {Pagination, Avatar} from "antd";
import UsersTable from "../../components/usersTable/usersTable";
import UsersFilter from "../../components/usersTable/usersFilter";
import axios from "axios";
import {Link} from "react-router-dom";
import AxiosRequest, {AxiosRequestWithImba} from "../../helpers/AxiosRequest";
import UsersBan from "../../components/usersTable/usersBan";
import UsersUnBan from "../../components/usersTable/usersUnBan";
import UsersDelete from "../../components/usersTable/usersDelete";
import UsersRstore from "../../components/usersTable/usersRestore";
import RoomBan from "../../components/usersTable/roomBan";

const UsersTablePage = (props) => {
// data state to store the TV Maze API data. Its initial value is an empty array
    console.log('props',props.match.params);
    const [users, setUsers] = useState(null);
    const [total, setTotal] = useState(0);
    const [per, setPer] = useState(10);
    const [filters, setFilters] = useState({imba_id: props.match.params.imba_id, per_page: 10});
    const columns = [
        {
            title: 'id',
            dataIndex: 'remote_user_id',
            key: 'id',
            render: text => <Link to={{
                pathname: `/${props.match.params.imba_id}/user/${text}`
            }}>{text}</Link>,
        },
        {
          title: 'avatar',
          key: 'avatar',
          render: (text, record) => <Avatar size={64} src={record.avatar_url} />
        },
        {
            title: 'login',
            dataIndex: 'login',
            key: 'login',
            render: text => <p>{text == 'NULL' ? 'NoName' : text}</p>,
        },
        {
            title: 'status',
            dataIndex: 'status',
            key: 'status',
            render: text => <p>{text == 'NULL' ? 'user' : text}</p>,
        },
        {
          title: 'Ban status',
          key: 'banStatus',
          dataIndex: 'bans',
          render: bans => {
              if (bans.length > 0)
              {
                  let ban = bans[bans.length-1];
                  let curr_date = new Date();
                  let unban_date = new Date(ban.unbanned_at)
                  if (curr_date>unban_date)
                  {
                      return (<p>not banned</p>)
                  }
                  let date = [pad(unban_date.getDate()), pad(unban_date.getMonth()+1), unban_date.getFullYear()].join('.');
                  let time = [pad(unban_date.getHours()), pad(unban_date.getMinutes())].join(':');
                  return (<p>banned for {`${date} ${time}`}</p>)
              } else
                return (<p>not banned</p>)
          }
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (text, record) => (
                <div>
                    <UsersBan record={record} imba_id={props.match.params.imba_id}/>
                    <UsersUnBan record={record} imba_id={props.match.params.imba_id}/>
                    {record.deleted_at!=null ?  <UsersRstore record={record} imba_id={props.match.params.imba_id}/> : <UsersDelete record={record} imba_id={props.match.params.imba_id}/>}
                </div>
            )
        }
    ];

    function pad(s) { return (s < 10) ? '0' + s : s; }

    function onChangePage(page, size) {
        setFilters({
            ...filters,  //take existing key-value pairs and use them in our new state,
            page: page   //define new key-value pair with new uuid and [].
        })
    }
    function onChangeSize(current, size) {
        setFilters({
            ...filters.per_page = size,  //take existing key-value pairs and use them in our new state,
        })
    }

    // Using useEffect to call the API once mounted and set the data
    useEffect(() => {
        
        (async () => {
            setTimeout(()=>{
                if(document.querySelector(".ant-spin-dot.ant-spin-dot-spin")!=null) {
                    //window.location.reload()
                }
            },15000)
            AxiosRequest("imba_users_get", filters)
                .then((data) => {
                    setUsers(data.data)
                    setTotal(data.total)
                    setPer(data.per_page)
                })
                .catch((error) =>{
                    console.log('error',error)
                   // window.location.href = `#/${props.match.params.imba_id}/signIn`
                });
        })();
    }, [filters]);

    const onChangeFilter = (values) => {
        values.imba_id = props.match.params.imba_id;
        values.per_page = per;
        setFilters(values)

    }
    return (
        <div className="App">
            <UsersFilter onChange={onChangeFilter}/>
            <UsersTable imba_id={props.match.params.imba_id} dataSource={users} columns={columns } total={total} per={per} />
            <Pagination
                className={'table-pagination'}
                showSizeChanger
                onShowSizeChange={onChangeSize}
                defaultCurrent={1}
                PageSize={per}
                total={total}
                onChange={onChangePage}
            />
        </div>

    );
}

export default UsersTablePage;